import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { reportWebVitals } from './hooks/useWebVitals'
import { installFocusAssist } from './components/ui/focusAssist'

// Keyboard: one Tab stop per radio group, arrow keys inside it, and focused
// chips scrolled clear of strip edges — app-wide, public pages included.
installFocusAssist()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

reportWebVitals()
